import styled from 'styled-components';

export const InfoMessage = styled.div`
  width: 100%;
  padding: 16px;
  background-color: var(--error-100);
  color: var(--error-700);
  border: 1px solid var(--error-700);
  border-radius: 4px;
  text-align: center;
`;
